import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    tableHeader: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    tableHorizontalContainer: {
        justifyContent: "space-evenly",
        flexDirection: "row",
        width: "100%"
    },
    participantBox: {
        justifyContent: "center",
        alignItems: "center",
        minWidth: 80,
        maxWidth: 90,
        height: 60
    },
    tableCenter: {
        justifyContent: "center",
        alignItems: "center",
        height: 100,
        width: 100
    },
    bottom: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    right: {
        justifyContent: "center",
        flexDirection: "column"
    },
    left: {
        justifyContent: "center",
        flexDirection: "column"
    },
    top: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    container: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    participantText: {
        textAlign: "center"
    },
    tableContainer: {
        width: 380,
        height: 400
    }
});

export default stylesheet;
